import { useState } from 'react';
import { Button, Form, Modal } from 'semantic-ui-react';
import './CreateProjectPartModal.scss';
import ProjectPart from '../../../../structures/projectPart';
import api from '../../../../utils/api';

interface CreateProjectPartModalProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    projectId: string;
    onSave: (part: ProjectPart) => void;
}

function CreateProjectPartModal({open, setOpen, projectId, onSave}:CreateProjectPartModalProps) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const create = async () => {
        let part = await api.createPart(projectId, name, description)
        onSave(part)
        setOpen(false);
    }
    return <Modal
        open={open}
        onClose={() => setOpen(false)}
        className='create-project-part-modal'
        centered={false}
        size='tiny'
    >
        <Modal.Header>Новая глава проекта</Modal.Header>
        <Modal.Content>
            <Form>
                <Form.Input label='Название' value={name} onChange={e => setName(e.target.value)}/>
                <Form.TextArea label='Описание' value={description} onChange={e => setDescription(e.target.value)}/>
            </Form>
        </Modal.Content>
        <Modal.Actions>
            <Button basic onClick={() => setOpen(false)}>Отмена</Button>
            <Button primary onClick={create}>Создать</Button>
        </Modal.Actions>
    </Modal>
};

export default CreateProjectPartModal;